/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
// MSC-1779: Component must be isolated from Retrofit
import Button from "../../../../Common/components/Buttons/Button/Button";
import MsxIcons from "../../../../Common/components/Icons/MsxIcons/MsxIcons";
import { selectConfigurationType, selectEventsData } from "../../../../Common/store/slices/common";
import t from "../../../../Common/utils/translation/translator";
import useCheckMobileScreen from "../../../../Common/utils/useCheckMobileScreen";
import {
  selectSelectedBundle,
  selectShowOnlyDifferentValues,
  setShowOnlyDifferentValues
} from "../../../../Retrofit/store/slices/retrofit";
// MSC-1780: Component must be isolated from Cartesian
import { selectSelectedAxis } from "../../../../Cartesian/store/slices/cartesian";

const ComparatorLine = ({
  type,
  opened,
  title,
  values,
  unit,
  isSectionHeader,
  isProductImages,
  headerBundles,
  compareData,
  onSelect,
  onRemoveSolutionFromCompare,
  renderValue, // New prop for custom rendering
  ...props
}) => {
  const isMobile = useCheckMobileScreen();
  const selectedBundle = compareData != null ? compareData : useSelector(selectSelectedBundle);
  const showOnlyDifferentValues = useSelector(selectShowOnlyDifferentValues);
  const configurationType = useSelector(selectConfigurationType);
  const selectedAxis = useSelector(selectSelectedAxis);
  const dispatch = useDispatch();

  const normalizeValue = (value) => {
    if (typeof value === "string") {
      const sortedSubstrings = value.replace(/\s/g, "").split(",").sort();
      return sortedSubstrings.join(",");
    }
    // if the value is an object, get the deepest props -> children -> first element
    if (typeof value === "object") {
      let children = value.props?.children;
      while (typeof children === "object") {
        if (Array.isArray(children)) {
          [children] = children; // children = children[0];
        } else {
          children = children.props?.children;
        }
      }
      return children;
    }

    // If the value is a number, convert it to a string
    if (typeof value === "number") {
      return value.toString();
    }
    return value;
  };

  const normalizedValues = values?.map(normalizeValue);
  const differentValues = normalizedValues?.some((value) => value !== normalizedValues[0]);

  const getSelectLabel = (bundleId) => {
    const isCartesian = configurationType === "CARTESIAN";
    if (isCartesian) {
      return selectedAxis?.id === bundleId ? t("msizer.ui.compare.selected") : title;
    }
    return selectedBundle?.id === bundleId
      ? t("msizer.ui.compare.selected")
      : t("msizer.ui.select.select_product_bundle_button_text");
  };

  const isSelectDiabled = (bundleId) => {
    const isCartesian = configurationType === "CARTESIAN";
    if (isCartesian) {
      return selectedAxis?.id === bundleId ? true : false;
    }
    return selectedBundle?.id === bundleId ? true : false;
  };

  useEffect(() => {
    if (headerBundles?.length === 1) {
      dispatch(setShowOnlyDifferentValues(false));
    }
  }, [headerBundles]);

  if (type === "header" || type === "footer") {
    return (
      headerBundles && (
        <div data-testid={`comparator-line-${type}`} className="ComparatorLineHeader flex space-x-1 md:space-x-5">
          {!isMobile && (
            <div className="flex-1 max-w-xs p-2">
              {type === "header" && headerBundles?.length > 1 && (
                <div className="flex space-x-2 items-center">
                  <input
                    className="checked:bg-primary cursor-pointer focus:ring-0"
                    type="checkbox"
                    checked={showOnlyDifferentValues}
                    onChange={
                      (e) => dispatch(setShowOnlyDifferentValues(e.target.checked))
                      // eslint-disable-next-line prettier/prettier
                    }
                  />

                  <span>{t("msizer.ui.compare.show_only_differences")}</span>
                </div>
              )}
            </div>
          )}
          {headerBundles.map((bundle, idx) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`${title}-bdl-id-${bundle.id}-${idx}`}
              className={`relative flex-1 md:p-2 border-x border-solid md:border-gray-400 border-gray-300 max-w-sm flex space-x-2 ${
                type === "header" && "border-t rounded-t"
              } ${type === "footer" && "border-b rounded-b"}`}
            >
              <qds-button
                onClick={() => onSelect(bundle)}
                class="flex-1 p-[0.25rem] rounded-sm mx-2 md:mx-7 my-2"
                {...(isSelectDiabled(bundle.id) ? { disabled: "" } : {})}
                text={getSelectLabel(bundle.id)}
              ></qds-button>
              {type === "header" && !isMobile && (
                <Button
                  onClick={() => onRemoveSolutionFromCompare(bundle)}
                  classes="p-[0.25rem] absolute top-0 right-0 bg-gray-400 hover:bg-gray-500 rounded-bl-lg transition-all duration-75"
                >
                  <MsxIcons name="close" size="nano" className="text-white" />
                </Button>
              )}
            </div>
          ))}
        </div>
      )
    );
  }

  return (
    (!showOnlyDifferentValues ||
      isSectionHeader ||
      isProductImages ||
      (showOnlyDifferentValues && differentValues)) && (
      <div
        data-testid="comparator-line"
        className={`ComparatorLine flex space-x-1 md:space-x-5 border-gray-100 border-solid
        ${!isProductImages && "border-b"}
        ${differentValues && !isSectionHeader && !isProductImages ? "bg-yellow-50" : ""}
        ${isSectionHeader ? "bg-gray-100 font-bold cursor-pointer" : ""}
      `}
        {...props}
      >
        {!isMobile && (
          <div className="flex-1 max-w-xs p-2 overflow-hidden text-ellipsis flex items-center space-x-2 select-none">
            {title !== "BUNDLE" && isSectionHeader && <div className="w-7" />}
            <span className="w-8 flex space-x-2">
              {isSectionHeader && (opened ? <BsChevronUp /> : <BsChevronDown />)}
              {differentValues && !isProductImages && <RiErrorWarningFill className="text-gray-500" />}
            </span>
            <span className="">{title}</span>
          </div>
        )}
        {values.map((value, idx) => (
          <div
            key={`${title}-value-${idx}`}
            className="flex-1 flex-col md:flex-row p-2 border-x border-solid border-gray-400 max-w-sm flex space-x-2 md:items-center"
          >
            {renderValue ? renderValue(value) : value} {/* Use renderValue if provided */}
          </div>
        ))}
      </div>
    )
  );
};

ComparatorLine.propTypes = {
  type: PropTypes.string,
  opened: PropTypes.bool,
  title: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.string),
  unit: PropTypes.string,
  isSectionHeader: PropTypes.bool,
  isProductImages: PropTypes.bool,
  headerBundles: PropTypes.array,
  compareData: PropTypes.array,
  onSelect: PropTypes.func,
  onRemoveSolutionFromCompare: PropTypes.func,
  renderValue: PropTypes.func // New prop type for custom rendering
};

ComparatorLine.defaultProps = {
  type: null,
  opened: false,
  title: "",
  values: [],
  unit: null,
  isSectionHeader: false,
  isProductImages: false,
  headerBundles: [],
  compareData: null,
  onSelect: () => {},
  onRemoveSolutionFromCompare: () => {},
  renderValue: null // Default to null
};

export default ComparatorLine;
